
export enum BudgetType {
    Fixed = 1,
    Capped = 2
}